<template>
  <div class="mention-dropdown" v-show="safeItems.length">
    <button v-for="(item, index) in safeItems" :key="item.id" type="button"
      :class="['mention-item', { active: index === selectedIndex }]" @click="selectItem(index)"
      @mouseenter="selectedIndex = index">
      <span class="mention-avatar" :style="{ background: item.color || avatarColorFor(item.name) }">{{ initials(item.name)
      }}</span>
      <span class="mention-meta">
        <span class="mention-name">{{ item.name }}</span>
        <span class="mention-type" v-if="item.type">{{ item.type }}</span>
      </span>
    </button>
  </div>
</template>

<script>
const AVATAR_PALETTE = [
  '#1e88e5', '#43a047', '#e53935', '#8e24aa', '#fb8c00',
  '#00897b', '#5e35b1', '#6d4c41', '#d81b60', '#546e7a',
];

export default {
  name: 'MentionList',
  props: {
    items: { type: Array, required: true },
    command: { type: Function, required: true }
  },
  data() {
    return { selectedIndex: 0 }
  },
  computed: {
    safeItems() {
      const isPrimitive = (rawValue) => typeof rawValue === 'string' || typeof rawValue === 'number'
      const rawItems = Array.isArray(this.items) ? this.items : []
      return rawItems
        .filter((rawItem) => rawItem && typeof rawItem === 'object' && rawItem.nodeType === undefined && rawItem.id != null)
        .map((rawItem) => ({
          id: rawItem.id,
          name: isPrimitive(rawItem.name) ? String(rawItem.name) : '',
          type: isPrimitive(rawItem.type) ? String(rawItem.type) : '',
          kind: isPrimitive(rawItem.kind) ? String(rawItem.kind) : 'user',
          color: isPrimitive(rawItem.color) ? String(rawItem.color) : null,
        }))
    },
  },
  watch: {
    items() {
      this.selectedIndex = 0
    }
  },
  methods: {
    initials(name) {
      if (!name) return '?'
      return String(name).split(' ').map(namePart => namePart[0]).join('').slice(0, 2).toUpperCase()
    },
    avatarColorFor(name) {
      const colorSeed = String(name || '?').charCodeAt(0) || 0;
      return AVATAR_PALETTE[colorSeed % AVATAR_PALETTE.length];
    },
    onKeyDown({ event }) {
      if (event.key === 'ArrowUp') { this.upHandler(); return true }
      if (event.key === 'ArrowDown') { this.downHandler(); return true }
      if (event.key === 'Enter' || event.key === 'Tab') { this.enterHandler(); return true }
      return false
    },
    upHandler() {
      const itemCount = this.safeItems.length
      if (!itemCount) return
      this.selectedIndex = (this.selectedIndex + itemCount - 1) % itemCount
    },
    downHandler() {
      const itemCount = this.safeItems.length
      if (!itemCount) return
      this.selectedIndex = (this.selectedIndex + 1) % itemCount
    },
    enterHandler() {
      this.selectItem(this.selectedIndex)
    },
    selectItem(index) {
      const item = this.safeItems[index]
      if (!item) return

      this.command({ id: item.id, label: item.name, kind: item.kind || 'user' })
    }
  }
}
</script>

<style scoped>
.mention-dropdown {
  background: #ffffff;
  border: 1px solid #e1e1e1;
  border-radius: 4px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
  padding: 4px;
  min-width: 240px;
  max-width: 320px;
  max-height: 280px;
  overflow-y: auto;
  font-family: "Roboto", -apple-system, BlinkMacSystemFont, "Segoe UI", Arial, sans-serif;
}

.mention-item {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 6px 8px;
  border: none;
  background: none;
  text-align: left;
  border-radius: 3px;
  cursor: pointer;
  font-family: inherit;
  color: #242424;
}

.mention-item.active,
.mention-item:hover {
  background: rgba(3, 50, 77, 0.08);
}

.mention-avatar {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  color: white;
  font-weight: 600;
  font-size: 11px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  letter-spacing: -0.02em;
}

.mention-meta {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.mention-name {
  font-weight: 500;
  font-size: 13px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.mention-type {
  font-size: 11px;
  color: #616161;
}

@media (max-width: 600px) {
  .mention-dropdown {
    min-width: 200px;
    max-width: calc(100vw - 24px);
  }
}
</style>
